import { BasicRequest } from "./basicRequest";

export class PreviewConsolidationRequest extends BasicRequest{
    public consolidationDefinitionId!:number;

    constructor(){
        super();
    }
}